import * as request from "../lib/lib";

const baseUrl = process.env.REACT_APP_BACKEND_URL + 'Reference';

export const getSchoolRanking = async (status,schoolId) => {
    const result = await request.get(`${baseUrl}/GetByStatus/${status}?schoolId=${schoolId}`);
    return result;
}

export const getPdfRanking = async (schoolId) => {
    
    const result = await request.getArchivePdfRef(`${baseUrl}/GetPublicRankingReferencePDF/${schoolId}`);
    return result;
}

export const getChildReportExcell = async (schoolId) => {
    const result = await request.get(`${baseUrl}/GetChildReportExcell?schoolId=${schoolId}`);

    return result;
}

export const getBookOfActions = async (dateFrom, dateTo) => {
    let url = `${baseUrl}/GetBookOfActions`;

    if (dateFrom && dateTo) {
        url += `?fromDate=${dateFrom}&toDate=${dateTo}`
    }

    const result = await request.get(url);

    return result;
}